export default __webpack_public_path__ + "static/media/ubiforecast-customer.b36a59d0.png";